import { render, staticRenderFns } from "./Makeup.vue?vue&type=template&id=5a5b2064&scoped=true"
import script from "./Makeup.vue?vue&type=script&lang=js"
export * from "./Makeup.vue?vue&type=script&lang=js"
import style0 from "./Makeup.vue?vue&type=style&index=0&id=5a5b2064&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5b2064",
  null
  
)

export default component.exports